import { useContext } from 'react';
import ViewerContext from './ViewerContext';

const useViewer = () => useContext(ViewerContext);

export default useViewer;
